import CONSTANTS from "../../assets/js/Constants"

const fDashboard = {
   statisticalTransportation: {},
   statisticalReminder: {},
   alertActivityTransportation: [],
   graphPriceActivity: {},
   graphPriceTime: {},
   graphActivityTransportation: {}
}
export default function(state = fDashboard, { type, payload }) {
   switch (type) {
      case CONSTANTS.ACTION.F_DASHBOARD.STATISTICAL_TRANSPORTATION:
         return { ...state, statisticalTransportation: payload }

      case CONSTANTS.ACTION.F_DASHBOARD.STATISTICAL_REMINDER:
         return { ...state, statisticalReminder: payload }

      case CONSTANTS.ACTION.F_DASHBOARD.ACTIVITY_TRANSPORTATION:
         return { ...state, alertActivityTransportation: payload }

      case CONSTANTS.ACTION.F_DASHBOARD.GRAPH_PRICE_ACTIVITY_TRANSPORTATION:
         return { ...state, graphPriceActivity: payload }

      case CONSTANTS.ACTION.F_DASHBOARD.GRAPH_PRICE_TIME_TRANSPORTATION:
         return { ...state, graphPriceTime: payload }

      case CONSTANTS.ACTION.F_DASHBOARD.GRAPH_ACTIVITY_TRANSPORTATION:
         return { ...state, graphActivityTransportation: payload }

      default:
         return { ...state }
   }
}
